import { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import __isEmpty from 'lodash/isEmpty';
import { useViewport } from 'hooks/3catinfo/useViewport';
import debounce from 'lodash.debounce';
import MenuAmp from './MenuAmp';
import MainMenu from './MainMenu/MainMenu';
import MenuSticky from './MenuSticky/MenuSticky';
import MenuSeo from './MenuSeo/Menu.seo';
import { usePublicitat } from 'hooks/usePublicitat';
import { useAmp } from 'next/amp';

export default function Component(props) {
    const isAmp = useAmp();
    const { isMobile, zoomNavigator } = useViewport();

    useEffect(() => {
        if (zoomNavigator == 2) {
            document.documentElement.classList.add('zoomed200');
        } else {
            document.documentElement.classList.remove('zoomed200');
        }

        if (zoomNavigator >= 4) {
            document.documentElement.classList.add('zoomed400');
        } else {
            document.documentElement.classList.remove('zoomed400');
        }
    }, [zoomNavigator]);

    const lastScrollY = useRef(0);

    const { hasTopBannerPublicitat } = usePublicitat();

    const [isMenuSticky, setIsMenuSticky] = useState(false);
    const [isSideMenuOpen, setIsSideMenuOpen] = useState('closed'); // 'opened', 'closing', 'closed'

    const handleClickOutside = useCallback(
        (event) => {
            if (event.target.nodeName !== 'BUTTON' && !event.target.closest('[data-opened-menu="true"]')) {
                if (isSideMenuOpen === 'opened' && isMenuSticky) {
                    setIsSideMenuOpen('closing');
                    setTimeout(() => {
                        setIsSideMenuOpen('closed'); // Se ejecuta después de 500ms
                    }, 500);
                }
            }
        },
        [isSideMenuOpen, isMenuSticky]
    );

    const handleUpdateMenuSticky = useCallback(() => {
        if (!isMobile) {
            if (isMenuSticky && isSideMenuOpen === 'opened') {
                setIsSideMenuOpen('closing');
                setTimeout(() => {
                    setIsSideMenuOpen('closed'); // Se ejecuta después de 500ms
                }, 500);
            }
        }

        if (Math.abs(window.scrollY - lastScrollY.current) < hasTopBannerPublicitat.current.SCROLL_THRESHOLD) {
            return;
        }

        lastScrollY.current = window.scrollY;

        let shouldBeSticky = window.scrollY > hasTopBannerPublicitat.current.SCROLL_THRESHOLD;
        setIsMenuSticky(shouldBeSticky);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMobile /*isMenuSticky*/, , isSideMenuOpen, hasTopBannerPublicitat]);

    const updateMenuSticky = useMemo(() => debounce(handleUpdateMenuSticky, 100), [handleUpdateMenuSticky]);

    useEffect(() => {
        window.addEventListener('click', handleClickOutside);
        window.addEventListener('scroll', updateMenuSticky);

        return () => {
            window.removeEventListener('click', handleClickOutside);
            window.removeEventListener('scroll', updateMenuSticky);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const renderMenu = () => {
        return (
            <>
                {!isMenuSticky ? (
                    <>
                        {!isAmp && !__isEmpty(props.itemsSeo) && <MenuSeo itemsSeo={props.itemsSeo} />}

                        {!isAmp ? (
                            <MainMenu
                                requiredServices={props.requiredServices}
                                isSideMenuOpen={isSideMenuOpen}
                                setIsSideMenuOpen={setIsSideMenuOpen}
                                tipus={props.tipus}
                                seccio={props.seccio}
                                temesDestacats={props.temesDestacats}
                                informatius={props.informatius}
                                temesGenerics={props.temesGenerics}
                                destacatsPortal={props.destacatsPortal}
                                podcasts={props.podcasts}
                                mostraAppsFlyerBanner={props.mostraAppsFlyerBanner}
                            />
                        ) : (
                            <MenuAmp itemsSeo={props.itemsSeo} />
                        )}
                    </>
                ) : (
                    <>
                        {!isAmp && <MenuSeo itemsSeo={props.itemsSeo} />}

                        {!isAmp ? (
                            <MenuSticky
                                requiredServices={props.requiredServices}
                                isMenuSticky={true}
                                isSideMenuOpen={isSideMenuOpen}
                                setIsSideMenuOpen={setIsSideMenuOpen}
                                tipus={props.tipus}
                                seccio={props.seccio}
                                estil={props.estil}
                                temesDestacats={props.temesDestacats}
                                informatius={props.informatius}
                                temesGenerics={props.temesGenerics}
                                destacatsPortal={props.destacatsPortal}
                                podcasts={props.podcasts}
                            />
                        ) : (
                            <MenuAmp itemsSeo={props.itemsSeo} />
                        )}
                    </>
                )}
            </>
        );
    };

    return (
        <>
            <div id='skiplinks'>
                <a href='#navegacio' accessKey='1' className='sr-only'>
                    Anar a la navegació principal
                </a>
                <a href='#contingut' className='sr-only' accessKey='c'>
                    Anar al contingut
                </a>
            </div>
            <header>{renderMenu()}</header>
        </>
    );
}
